import React, { useState, useEffect ,useMemo} from "react";
import {
  setCampaignId,
  resetCampaignData,
  setComplaiceStatus,
  setCampaignHtml,
  setCampaignStatus,
  setCategory,
  setCampaignWidget,
  setPublishedUrl,
 setscriptCode
} from "ReduxStore/Slices/campaignSlice";
import {
  postCampaignData,
  putCampaignData,
  postCampaignPublish,
  getAdvisorScript
} from "api/CampaignApi";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const ComplianceEnabledBottomSection = ({ saveCampaignDraft, handleComplianceRequest, handleCancelClick, handlePublish, updatedCampaignStatus, publishedButtonPermission }) => {
  const {
    campaignType,
    complaiceStatus,
    campaignViewMode,
    campaignStatus
  } = useSelector((state) => state.campaignSetter);
  const userData = useSelector((state) => state.userSetter);

  return <>
    {(!campaignViewMode) ?
      userData.role === "compliance" ? (
        <>
          <a
            to=""
            onClick={() => saveCampaignDraft()}
            className="lg_btn primary"
            disabled={
              complaiceStatus === "Pending" ||
                complaiceStatus === "Approved"
                ? true
                : false
            }
            style={
              complaiceStatus === "Pending" ||
                complaiceStatus === "Approved"
                ? { opacity: 0.5 }
                : { opacity: 1 }
            }
          >
            Save
          </a>

          <a
            to=""
            onClick={() => handleComplianceRequest("Approved")}
            className="lg_btn secondary"
            disabled={
              complaiceStatus === "Pending"
                ? false
                : true
            }
            style={
              complaiceStatus === "Pending"
                ? { opacity: 1 }
                : { opacity: 0.5 }
            }
          >
            Approve
          </a>


          <a
            to=""
            onClick={() => handleComplianceRequest("Rejected")}
            className="lg_btn primary"
            disabled={
              complaiceStatus === "Pending"
                ? false
                : true
            }
            style={
              complaiceStatus === "Pending"
                ? { opacity: 1 }
                : { opacity: 0.5 }
            }
          >
            Reject
          </a>


          <a
            to=""
            onClick={() => handleCancelClick()}
            className="lg_btn tertiary"
          >
            Cancel
          </a>
        </>
      ) : (
        <>

          <a
            to=""
            onClick={() => saveCampaignDraft()}
            className="lg_btn primary"
          >
            Save
          </a>

          <a
            to=""
            onClick={() => handleComplianceRequest("Pending")}
            className="lg_btn secondary"
            disabled={(complaiceStatus === "Approved" ||
              complaiceStatus === "Pending") ? true : false}
            style={(complaiceStatus === "Approved" ||
              complaiceStatus === "Pending") ? { opacity: 0.5 } : { opacity: 1 }}
          >
            Submit to Compliance
          </a>


          {complaiceStatus === "Approved" &&
            campaignType === "publishedContent" && (
              <a
                to=""
                className="lg_btn primary"
                onClick={() => {
                  if (publishedButtonPermission) {
                    handlePublish()
                  }
                }}
                style={publishedButtonPermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}
              >
                Publish Content
              </a>
            )}
          <a
            to=""
            onClick={() => handleCancelClick()}
            className="lg_btn tertiary"
          >
            Cancel
          </a>
        </>
      ) :
      <>
        {
          (campaignStatus === "Active" && campaignType === "email") && <a
            to=""
            onClick={() => updatedCampaignStatus("Paused")}
            className="lg_btn tertiary"
          >
            Cancel Campaign
          </a>
        }
        {
          (campaignStatus === "Paused" && campaignType === "email") && <a
            to=""
            onClick={() => updatedCampaignStatus("Active")}
            className="lg_btn primary"
          >
            Activate Campaign
          </a>
        }
      </>
    }
    {

    }
  </>

}

const ComplianceDisabledBottomSection = ({ saveCampaignDraft, handlePublish, updatedCampaignStatus, publishedButtonPermission }) => {
  const {
    campaignType,
    campaignViewMode,
    campaignStatus
  } = useSelector((state) => state.campaignSetter);
  const dispatch = useDispatch();
  return <>
    {
      
      (!campaignViewMode) ? <>
         

        {campaignType === "publishedContent" &&
          <a
            to=""
            onClick={() => {
              if (publishedButtonPermission) {
                handlePublish()
              }
            }}
            className="lg_btn secondary"
            style={publishedButtonPermission ? { opacity: 1 } : { cursor: 'not-allowed', opacity: 0.5 }}
          >
            Publish Content
          </a>
        }
        <a
          to=""
          onClick={() => saveCampaignDraft()}
          className="lg_btn primary"
        >
          Save
        </a>
        <a
          to=""
          onClick={() => dispatch(resetCampaignData())}
          className="lg_btn tertiary"
        >
          Cancel
        </a>
      </> : <>
        {
          (campaignStatus === "Active" && campaignType === "email") && <a
            to=""
            onClick={() => updatedCampaignStatus("Paused")}
            className="lg_btn tertiary"
          >
            Cancel Campaign
          </a>
        }
        {
          (campaignStatus === "Paused" && campaignType === "email") && <a
            to=""
            onClick={() => updatedCampaignStatus("Active")}
            className="lg_btn primary"
          >
            Activate Campaign
          </a>
        }
      </>
    }



  </>

}
export default function CampaignBottomSection({ publishedButtonPermission }) {
  const history = useHistory();
  const {
    html,
    campaignType,
    campaignName,
    campaignSubject,
    campaignAudienceId,
    campaignId,
    campaignEmail,
    campaignDescription,
    campaignEditMode,
    campignTemplateId,
    complaiceStatus,
    campaignABTestEnabled,
    campaignABTestChecked,
    campaingABTestData,
    campaignStatus,
    widgetType,
    wordpressFlag,
    category,
    cc,
    bcc,
    publishedUrl,
    scriptCode,

    
  } = useSelector((state) => state.campaignSetter);
  const userData = useSelector((state) => state.userSetter);
  const dispatch = useDispatch();

  const [apiKey, setapiKey] = useState("");
  // const memoizedHistory = useMemo(() => history, [history]);

  useEffect(() => {
    dispatch(setPublishedUrl(""))
    dispatch(setscriptCode(""))
    setapiKey("");
    console.log("LOCATION CHANGED")
    
  }, [history.location.pathname, history.location.search, history.location.hash]);


  useEffect(() => {

  }, [complaiceStatus, campaignStatus, publishedButtonPermission]);

  const saveCampaignDraft = (e) => {

    if (campaignEditMode) {
      var data = {
        name: campaignName,
        description: campaignDescription,
        subject: campaignSubject,
        data: "",
        templateId: campignTemplateId,
        fromEmail: campaignEmail,
        audienceId: campaignAudienceId === null ? null : campaignAudienceId,
        type: campaignType,
        isDraft: true,
        cc: cc,
        bcc: bcc
      };
      var abTestCampaignAData = {
        name: campaignName,
        description: campaignDescription,
        subject: campaignSubject,
        data: '',
        templateId: campignTemplateId,
        fromEmail: campaignEmail,
        audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
        type: campaignType,
        isDraft: true,
        isABTest: true,
        cc: cc,
        bcc: bcc,
        ABTestData: {
          ABTestCampaignId: campaingABTestData.campaignABTestId,
          variationType: campaingABTestData.campaignABTestVariation,
          samplePercentage: campaingABTestData.campaignABTestPercentage,
          waitTime: campaingABTestData.campaignABTestWaitTime,
          decidingParameter: campaingABTestData.campaignABTestDecidingParameter,
          subject: campaingABTestData.campaignABTestSubject,
        },
 
      };
      if (campaignABTestEnabled && campaignABTestChecked) {

        putCampaignData(abTestCampaignAData, campaignId)
          .then((response) => {
            dispatch(setCampaignId(response.id));
            dispatch(setComplaiceStatus("Editing"));
            dispatch(setCampaignHtml(null))
            dispatch(setCategory(response.category))

            toast.success("Your campaign has been saved as a draft.");
          })
          .catch((error) => {
            toast.error("Something went wrong. Please try again.");
          });
      } else {
        putCampaignData(data, campaignId)
          .then((response) => {
            dispatch(setCampaignId(response.id));
            dispatch(setComplaiceStatus("Editing"));
            dispatch(setCampaignHtml(null))
            dispatch(setCategory(response.category))


            toast.success("Your campaign has been saved as a draft.");
          })
          .catch((error) => {
            toast.error("Something went wrong. Please try again.");
          });
      }

    } else if (!campaignName == "") {
      var data = {
        name: campaignName,
        description: campaignDescription,
        subject: campaignSubject,
        data: "",
        fromEmail: campaignEmail,
        templateId: campignTemplateId,
        audienceId: campaignAudienceId === "" ? null : campaignAudienceId,
        type: campaignType,
        isDraft: true,
        cc: cc,
        bcc: bcc
      };
      var abTestCampaignAData = {
        name: campaignName,
        description: campaignDescription,
        subject: campaignSubject,
        data: '',
        fromEmail: campaignEmail,
        templateId: campignTemplateId,
        audienceId: campaignAudienceId === '' ? null : campaignAudienceId,
        type: campaignType,
        isDraft: true,
        isABTest: true,
        ABTestData: {
          variationType: campaingABTestData.campaignABTestVariation,
          samplePercentage: campaingABTestData.campaignABTestPercentage,
          waitTime: campaingABTestData.campaignABTestWaitTime,
          decidingParameter: campaingABTestData.campaignABTestDecidingParameter,
          subject: campaingABTestData.campaignABTestSubject,
        },
        cc: cc,
        bcc: bcc
      };
      if (campaignABTestEnabled && campaignABTestChecked) {
        if (campaingABTestData.campaignABTestVariation !== "") {
          campaignId !== ""
            ? postCampaignData(abTestCampaignAData, campaignId)
              .then((response) => {
                dispatch(setCampaignId(response.id));
                dispatch(setCategory(response.category))

                toast.success("Your campaign has been saved as a draft.");
              })
              .catch((error) => {
                toast.error("Something went wrong. Please try again.");
              })
            : postCampaignData(abTestCampaignAData)
              .then((response) => {
                dispatch(setCampaignId(response.id));
                dispatch(setCategory(response.category))

                toast.success("Your campaign has been saved as a draft.");
              })
              .catch((error) => {
                toast.error("Something went wrong. Please try again.");
              });
        } else {
          toast.info("Please select variation type.")
        }

      } else {
        campaignId !== ""
          ? postCampaignData(data, campaignId)
            .then((response) => {
              dispatch(setCampaignId(response.id));
              dispatch(setCategory(response.category))

              toast.success("Your campaign has been saved as a draft.");
            })
            .catch((error) => {
              toast.error("Something went wrong. Please try again.");
            })
          : postCampaignData(data)
            .then((response) => {
              dispatch(setCampaignId(response.id));
              dispatch(setCategory(response.category))

              toast.success("Your campaign has been saved as a draft.");
            })
            .catch((error) => {
              toast.error("Something went wrong. Please try again.");
            });
      }

    } else {
      toast.info("Please enter campaign name");
    }
  };

  const updatedCampaignStatus = (req) => {
    var data = {
      status: req,
      ABTestData: {
        ABTestCampaignId: campaingABTestData.campaignABTestId
      },
    };
    putCampaignData(data, campaignId)
      .then(() => {
        dispatch(setCampaignStatus(data.status));
        toast.success("Your campaign has been Updated.");
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again.");
      });

  }
  const handlePublish = () => {
    if ( !html && (campignTemplateId == "" || campignTemplateId == null)) {
      toast.info("Please design your template first");
      console.log("hj" ,html)
    } else {
      dispatch(setscriptCode(""))
      setapiKey("")
      postCampaignPublish(campaignId,wordpressFlag)
        .then((response) => {
          toast.success("The webpage campaign has been published!");
          dispatch( setPublishedUrl(response.url));
 
          if(html){
            getAdvisorScript(campaignId)
            .then(res=>{
              if (res) {
                dispatch(setscriptCode(res.script))
              setapiKey(res.apiKey)
              if (window.location.href.slice(-1) != '#')
                window.location.href = window.location.href+"#"
              }
              console.log(res)

            }).catch(e=>{console.log(e)})
          }
          
        })
        .catch((error) => {
          toast.error("Something went wrong. Please try again.");
        });
    }
  };

  const isValidCampaign = () => {

    if (campaignABTestEnabled && campaignABTestChecked) {
      if (campaingABTestData.campaignABTestVariation === "" || campaingABTestData.campaignABTestDecidingParameter === "") {
        toast.error('Please fill all the fields');
        return false
      } else {
        if (campaingABTestData.campaignABTestVariation === "Subject") {
          if (campaignSubject == campaingABTestData.campaignABTestSubject) {
            toast.error("Subject A and Subject B should not be same");
            return false
          }
        } if (campaignAudienceId === '' || campaignAudienceId === null) {
          toast.error('Please Select Audience');
          return false
        } else if (campaignEmail === '' || campaignEmail === null) {
          toast.error('Please Enter From Email');
          return false
        } else if (campaignSubject === '' || campaignSubject === null) {
          toast.error('Please Enter subject line for Campaign');
          return false
        } else if (campignTemplateId === '' || campignTemplateId === null) {
          toast.error('Please Create Design First');
          return false
        }
        return true
      }
    } else {
      if (campaignType === "email") {
        if (campaignAudienceId === '' || campaignAudienceId === null) {
          toast.error('Please Select Audience');
          return false
        } else if (campaignEmail === '' || campaignEmail === null) {
          toast.error('Please Enter From Email');
          return false
        } else if (campaignSubject === '' || campaignSubject === null) {
          toast.error('Please Enter subject line for Campaign');
          return false
        } else if (campignTemplateId === '' || campignTemplateId === null) {
          toast.error('Please Create Design First');
          return false
        }
      }
      return true
    }
  }

  const handleComplianceRequest = (req) => {
    var data = {
      complianceStatus: req,
      ABTestData: {
        ABTestCampaignId: campaingABTestData.campaignABTestId
      }
    };
    if (req === "Pending") {
      if (isValidCampaign()) {
        putCampaignData(data, campaignId)
          .then(() => {
            if (req === "Approved") {
              toast.success(`The campaign has been approved`);
            } else if (req === "Rejected") {
              toast.success(`The campaign  has been rejected.`);
            } else if (req === "Pending") {
              toast.success(`The campaign has been submitted for approvals.`);
            }
            history.push("/admin/campaign/all");
          })
          .catch((error) => {
            toast.error("Something went wrong. Please try again.");
          });
      }
    } else {
      putCampaignData(data, campaignId)
        .then(() => {
          if (req === "Approved") {
            toast.success(`The campaign has been approved`);
          } else if (req === "Rejected") {
            toast.success(`The campaign  has been rejected.`);
          } else if (req === "Pending") {
            toast.success(`The campaign has been submitted for approvals.`);
          }
          history.push("/admin/campaign/all");
        })
        .catch((error) => {
          toast.error("Something went wrong. Please try again.");
        });
    }

  };

  const handleCancelClick = () => {
    history.push("/admin/campaign/all");
  };

  return (
    <>

      {
        scriptCode &&  <>         <div
        style={{
          //  width: "90%",
          backgroundColor: "#F5F5F5",
          marginBottom: "30px",
          marginTop: "1%",
          minHeight: "100px",
          borderRadius: "10px",
          padding: "10px",
        }}

      >
        <ul>
          <li style={{position:"relative"}} >
            {/* <a
              href="#"
              type="button"
              id= 'cpy-btn'
              onClick={(e)=> navigator.clipboard.writeText(scriptCode)}
              // style={{
              //   display: "block",
              //   marginLeft: "98%",
              //   borderWidth: "0px",
              // }}
            >
              <i class="far fa-copy"></i>
            </a> */}
            <button class="integration-checklist__copy-button" onClick={(e)=> navigator.clipboard.writeText(scriptCode)}>   
</button>




          </li>
          <li>
            <pre
              style={{
                fontSize: "large",
                textAlign: "start",
              }}
            >
              {scriptCode}
            </pre>
          </li>

        </ul>
      </div>
              {widgetType == 'footer' && <div>{`Copy and paste this code into your website HTML anywhere within the <body> tag.`}</div>}

      </>}


      {
        apiKey &&  <>         <div
        style={{
          //  width: "90%",
          backgroundColor: "#F5F5F5",
          marginBottom: "30px",
          marginTop: "1%",
          minHeight: "100px",
          borderRadius: "10px",
          padding: "10px",
        }}

      >
        <ul>
          <li style={{position:"relative"}} >
            {/* <a
              href="#"
              type="button"
              id= 'cpy-btn'
              onClick={(e)=> navigator.clipboard.writeText(scriptCode)}
              // style={{
              //   display: "block",
              //   marginLeft: "98%",
              //   borderWidth: "0px",
              // }}
            >
              <i class="far fa-copy"></i>
            </a> */}
            <button class="integration-checklist__copy-button" onClick={(e)=> navigator.clipboard.writeText(apiKey)}>   
</button>




          </li>
          <li>
            <pre
              style={{
                fontSize: "large",
                textAlign: "start",
              }}
            >
              ApiKey: {apiKey}
            </pre>
          </li>

        </ul>
      </div>

      </>}
      { publishedUrl !== "" && (
        <p
          className="campaign_text"
          style={{ marginTop: 50, fontWeight: "bold", fontSize: 18 }}
        >
          Published URL : &nbsp;&nbsp;
          <a href={publishedUrl} target="_blank">
            {publishedUrl}
          </a>
        </p>
      )}

      <div className="save_draft_btn d-flex justify-content-center align-items-start">
        {userData.companyLevelComplaiceFlag === true ? (
          <ComplianceEnabledBottomSection saveCampaignDraft={saveCampaignDraft} handleComplianceRequest={handleComplianceRequest} handleCancelClick={handleCancelClick} handlePublish={handlePublish} updatedCampaignStatus={updatedCampaignStatus} publishedButtonPermission={publishedButtonPermission} />
        ) : (
          <ComplianceDisabledBottomSection saveCampaignDraft={saveCampaignDraft} handlePublish={handlePublish} updatedCampaignStatus={updatedCampaignStatus} publishedButtonPermission={publishedButtonPermission} />
        )}
      </div>
    </>
  );
}
